import React from 'react';

export class SupervisorAvatar extends React.Component {
   render() {
      return <div className='neo-icon-supervisor'></div>;
   }
};
